import { getConfigByCode } from '@/api/setting'
import store from '@/store'

export function importStyleByConfig() {
  const params = {
    code: 'clientEndSystemStyle'
  }
  return getConfigByCode(params).then((response) => {
    if (response.code === 200) {
      console.log('正在应用的系统风格:', response.data.configValue)

      let styleImportPromise

      switch (response.data.configValue) {
        case 'darkSkin':
          styleImportPromise = import('@/styles/dark.scss')
          store.commit('user/SET_SKIN', 'darkSkin')
          break
        case 'lightSkin':
          styleImportPromise = import('@/styles/index.scss')
          store.commit('user/SET_SKIN', 'lightSkin')
          break
        case 'middleSkin':
          styleImportPromise = import('@/styles/middle.scss')
          store.commit('user/SET_SKIN', 'middleSkin')
          break
        // case 'middleSkin':
        //   styleImportPromise = import('@/styles/guoqing.scss')
        //   store.commit('user/SET_SKIN', 'guoqingSkin')
        //   break
        case 'guoqingSkin':
          styleImportPromise = import('@/styles/guoqing.scss')
          store.commit('user/SET_SKIN', 'guoqingSkin')
          break
        case 'newYearSkin':
          styleImportPromise = import('@/styles/newYear.scss')
          store.commit('user/SET_SKIN', 'newYearSkin')
          break
        default:
          styleImportPromise = import('@/styles/middle.scss')
          store.commit('user/SET_SKIN', 'middleSkin')
      }

      // 返回样式加载的 Promise
      return styleImportPromise
    }
    return Promise.reject(new Error('未获取到有效的系统风格配置'))
  })
}
